import { useDispatch, useSelector } from "react-redux";
import {
    setDisableTakePhotoBtn,
    setIsMeasurementListDrawerOpen,
    setMeasurementList,
    setMeasurementToastMsgStatus,
    setShowMeasurementToastPopup,
} from "../../reducers/measurement-reducer";
import useLanguageChange from "../../hooks/useLanguageChange";
import googleEvent from "../../services/googleEvent";
import { LogFirebase } from "../../services/firestore";
import measurementService from "../../services/measurementService";
import { ENABLED } from "../../constants/Constants";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../../constants/PublicVariables";
import { EVENT_NAME } from "../../constants/GTagConstants";
import { AR_STATUS } from "../../constants/MeasurementConstants";
import { NOTIFICATION_TYPES } from "../../constants/DataTrackNotificationConstants";
import { isSilentObserverAvailable } from "../../shared/function";
import { sendDataTrack } from "../../shared/dataTrackFunction";

const MeasurementMenubar = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();
    const { measurementList, disabledUndoButton, isMeasurementListDrawerOpen, disabledTakePhotoButton } = useSelector((state) => state.measurement);

    const openMeasurementListDrawer = () => {
        // Check if thumb container is open then close it
        const ImageContainerDiv = document.querySelector(".saved-image-sidebar");
        if (ImageContainerDiv?.classList?.contains("active")) {
            const imageContainerToggleBtn = document.querySelector("#image-container-toggle-btn");
            imageContainerToggleBtn?.click();
        }

        dispatch(setIsMeasurementListDrawerOpen(!isMeasurementListDrawerOpen));
    };

    const undoMeasurement = () => {
        if (measurementList?.length > 0) {
            googleEvent.logEvent(EVENT_NAME.MEASUREMENT_UNDO_TAPPED);
            LogFirebase("Measurement", "send_msg", "undoMeasureList");
            measurementService.commonFuncForSendingARStatusDataTrack(AR_STATUS.UNDO_MEASUREMENT);
            measurementService.undoMeasureList();
        }
    };

    const clearAllMeasurement = () => {
        googleEvent.logEvent(EVENT_NAME.MEASUREMENT_CLEARALL_TAPPED);
        LogFirebase("Measurement", "send_msg", "clearMeasureList");
        measurementService.commonFuncForSendingARStatusDataTrack(AR_STATUS.CLEAR_MEASUREMENT);
        measurementService.clearMeasureList();
    };

    const stopMeasurement = () => {
        googleEvent.logEvent(EVENT_NAME.MEASUREMENT_STOPPED);
        measurementService.stopMeasurement();
        dispatch(setShowMeasurementToastPopup(false));
        dispatch(setMeasurementToastMsgStatus(""));
    };

    const measurementPhotosCaptureFromVideo = () => {
        googleEvent.logEvent(EVENT_NAME.MEASUREMENT_TAKE_PHOTO_TAPPED);
        btnDisableWhileCapture();
        sendSaveMeasurementLiveStreamMsg();
    };

    const sendSaveMeasurementLiveStreamMsg = () => {
        const msg = {
            notification_type: NOTIFICATION_TYPES.TAKE_PHOTO.TO_STREAMING_USER,
            identity: CALL_DATA.localIdentity,
            device_type: GLOBAL_MEETING_DATA.device_type,
            is_from_measurement: true,
        };
        LogFirebase("Measurement", "LiveStream-send_msg", "Save photo");
        sendDataTrack(msg);
    };

    const btnDisableWhileCapture = () => {
        if (!disabledTakePhotoButton) {
            dispatch(setDisableTakePhotoBtn(true));
        }
        setTimeout(() => {
            dispatch(setDisableTakePhotoBtn(false));
        }, 2000);
    };
    return (
        <div className='markup-menu'>
            <div className='markup-menu-in'>
                {GLOBAL_MEETING_DATA.isAgent && (
                    <>
                        <div className='markup-menu-item right-border mob-markup-menu-item markup-menu-item-clear' data-testid='measurement-menu'>
                            <div className='markup-menu-item-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width m-hide'>
                                <button
                                    className='btn markup-menu-btn'
                                    disabled={measurementList?.length < 1}
                                    onClick={clearAllMeasurement}
                                    data-testid='measurement-clear-button'
                                >
                                    <span className='btn-icon icon-clear'></span>
                                    <span className='mob-btn-text'>{localisedValues["clear_all"]}</span>
                                </button>
                                <div className='custom-tooltip-content text-nowrap'>
                                    <div className='custom-tooltip-in'>
                                        <p>{localisedValues["clear_all"]}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='markup-menu-item' data-testid='measurement-menu'>
                            <div className='markup-menu-item-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width m-hide'>
                                <button
                                    className='btn markup-menu-btn'
                                    disabled={measurementList?.length < 1 || disabledUndoButton}
                                    onClick={undoMeasurement}
                                    data-testid='undo-measurement'
                                >
                                    <span className='btn-icon icon-undo'></span>
                                </button>
                                <div className='custom-tooltip-content text-nowrap'>
                                    <div className='custom-tooltip-in'>
                                        <p>{localisedValues["undo"]}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {PublicVariables.featureFlag?.SAVEARIMAGE === ENABLED && (
                            <div className='markup-menu-item'>
                                <div className='markup-menu-item-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width m-hide'>
                                    <button
                                        className='btn markup-menu-btn'
                                        disabled={disabledTakePhotoButton}
                                        onClick={measurementPhotosCaptureFromVideo}
                                    >
                                        <span className='btn-icon icon-camera'></span>
                                    </button>
                                    <div className='custom-tooltip-content text-nowrap'>
                                        <div className='custom-tooltip-in'>
                                            <p>{localisedValues["take_photo"]}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className='markup-menu-item right-border'>
                            <div className='markup-menu-item-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width m-hide'>
                                <button
                                    className='btn markup-menu-btn open-sidebar-button'
                                    disabled={measurementList?.length == 0}
                                    onClick={openMeasurementListDrawer}
                                >
                                    <span className='btn-icon icon-measurement-list'></span>
                                </button>
                                <div className='custom-tooltip-content text-nowrap'>
                                    <div className='custom-tooltip-in'>
                                        <p>{localisedValues["measurements"]}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                {!isSilentObserverAvailable() && (
                    <div className='markup-menu-item mob-markup-menu-item markup-menu-exit' data-testid='measurement-menu'>
                        <div className='markup-menu-item-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width m-hide'>
                            <button className='btn markup-menu-btn' onClick={stopMeasurement} data-testid='stop-measurement'>
                                <span className='btn-icon icon-close'></span>
                                <span className='mob-btn-text'>{localisedValues["exit"]}</span>
                            </button>
                            <div className='custom-tooltip-content text-nowrap'>
                                <div className='custom-tooltip-in'>
                                    <p>{localisedValues["exit"]}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MeasurementMenubar;
